import React from 'react';

const MusicPlayerContext = React.createContext();

export { MusicPlayerContext };
